import React from 'react';
import { Button, DatePicker, Form, Input, Select } from 'antd';
import { openNotification } from '../../../utils';
import dayjs from 'dayjs';
import { APP_LOCAL_DATE_FORMAT } from 'config/constants';
import { listProfessionsAll } from '../../professions/services/professionService';
import { createInspectorProfession, updateInspectorProfession, getInspectorProfession } from '../services/inspector-professionService';
import { CreateInspectorProfessionDto } from '../types/InspectorProfession';

export default function InspectorProfessionForm({ id, onSuccess, referenceId }: { id?: number; onSuccess: () => void; referenceId?: number }) {
  const [form] = Form.useForm<CreateInspectorProfessionDto>();
  
  const [professionOptions, setProfessionOptions] = React.useState<any[]>([]);
  React.useEffect(() => {
    (async () => {
      if (id) {
        const d: any = await getInspectorProfession(id);
        const data: any = { ...d };
        if (data.graduationDate) data.graduationDate = dayjs(data.graduationDate);
        if (data.registrationDate) data.registrationDate = dayjs(data.registrationDate);
        if (data.profession) data.profession = typeof data.profession === 'object' ? data.profession.id : data.profession;
        form.setFieldsValue(data);
      } else {
        form.resetFields();
      }
      const list: any[] = await listProfessionsAll();
      const current = form.getFieldValue('profession');
      let opts = Array.isArray(list) ? list.filter((o: any) => o?.isActive) : [];
      if (current && Array.isArray(list) && !opts.some((o: any) => o.id === current)) {
        const found = list.find((o: any) => o.id === current);
        if (found) opts = [found, ...opts];
      }
      setProfessionOptions(opts);
    })();
  }, [id, form]);
  const onFinish = async (values: CreateInspectorProfessionDto) => {
    const data: any = { ...values }; if (data.graduationDate) data.graduationDate = data.graduationDate.format('YYYY-MM-DD'); if (data.registrationDate) data.registrationDate = data.registrationDate.format('YYYY-MM-DD'); if (referenceId !== undefined) data.account = { id: referenceId };
    try {
      if (id) {
        await updateInspectorProfession(id, data);
        openNotification('success', 'Başarılı', 'P.K.M Meslek Güncellendi');
      } else {
        await createInspectorProfession(data);
        openNotification('success', 'Başarılı', 'P.K.M Meslek Eklendi');
      }
      onSuccess();
    } catch (e: any) {
      let message = 'P.K.M Meslek işlemi başarısız';
      if (e?.message) {
        try {
          const payload = JSON.parse(e.message);
          if (payload?.message) message = payload.message;
        } catch {
          message = e.message;
        }
      }
      openNotification('error', 'Hata', message);
    }
  };
  return (
    <>
      
      <Form form={form} onFinish={onFinish} layout='vertical'>
      <Form.Item name='profession' label='Meslek' rules={[{ required: true, message: 'Meslek alanı zorunludur' }]}>
        <Select showSearch filterOption={(input, option) => ((option?.children?.toString()) || '').toLocaleLowerCase('tr').includes(input.toLocaleLowerCase('tr'))} placeholder='Seçiniz' style={{width:'100%'}}>
          {professionOptions.map(o => (
            <Select.Option key={o.id} value={o.id} disabled={o?.isActive === false}>
              {o.name ?? o.id}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item name='graduationDate' label='Mezuniyet Tarihi' rules={[{ required: true, message: 'Mezuniyet tarihi zorunludur' }]}>
        <DatePicker
          format={APP_LOCAL_DATE_FORMAT}
          placeholder='Seçiniz'
          style={{width:'100%'}}
          disabledDate={(d) => d ? d > dayjs().endOf('day') : false}
        />
      </Form.Item>
      <Form.Item name='diplomaNumber' label='Diploma Numarası' rules={[{ required: true, message: 'Diploma numarası zorunludur' }]}>
        <Input style={{width:'100%'}} />
      </Form.Item>
      <Form.Item name='registrationNumber' label='Kayıt Numarası' rules={[{ required: true, message: 'Kayıt numarası zorunludur' }]}>
        <Input style={{width:'100%'}} />
      </Form.Item>
      <Form.Item name='registrationDate' label='Kayıt Tarihi' rules={[{ required: true, message: 'Kayıt tarihi zorunludur' }]}>
        <DatePicker
          format={APP_LOCAL_DATE_FORMAT}
          placeholder='Seçiniz'
          style={{width:'100%'}}
          disabledDate={(d) => d ? d > dayjs().endOf('day') : false}
        />
      </Form.Item>
      <Form.Item name='idNumber' label='ID Numarası' rules={[{ required: true, message: 'ID numarası zorunludur' }]}>
        <Input style={{width:'100%'}} />
      </Form.Item>
      <Button htmlType='submit' type='primary' block>Kaydet</Button>
    </Form>
    </>
  );
}
